import { IS_MIX_CATALOG } from "@/config/browserBoard";

// routerのpathnameはbasepath("/b/{slug}"や"/mix")除去済みで渡ってくる
const MIX_BOARD_THREAD_ROUTE_PATTERN = /^\/([^/]+)\/thread\//u;

/**
 * router内pathnameがスレッドページか。mixでは板slug付き形も対象にする。
 * entry(Header/スクロール復元)から参照されるため、板スコープ本体
 * (threadBoardScope)とは別モジュールにして初期グラフを太らせない。
 */
export function isThreadRoutePath(
  routePath: string,
  isMixCatalog: boolean = IS_MIX_CATALOG,
): boolean {
  if (routePath.startsWith("/thread/")) return true;
  return isMixCatalog && MIX_BOARD_THREAD_ROUTE_PATTERN.test(routePath);
}

/**
 * 板slug付きスレパスから対象板slugを取り出す唯一のパーサ。板slug付き形で
 * なければundefined。mount部を含む生pathnameを持つ呼び出し元は、mountを
 * 外してからここへ渡す(threadBoardScopeのparseMixThreadSlug)。
 *
 * mixかどうかは判定しない(呼び出し側が板スコープ解決やmountプレフィックスの
 * 一致で判定する)。
 *
 * ヘッダが `window.location` ではなくrouterのpathnameを渡すのは、
 * @tanstack/historyが `pushState` をmicrotaskへ遅延させるため。SPA遷移を
 * 起こしたrenderの時点では `window.location.pathname` は前のURLのままで、
 * renderで板名を出すヘッダは遷移先のslugを取り落とす(遷移で再mountしないので、
 * mount時のsnapshot再検査で追いつくuseThreadBoardScopeとは異なり、popstateが
 * 来るまで古い値で固定される)。
 */
export function parseMixRouteThreadSlug(routePath: string): string | undefined {
  const raw = MIX_BOARD_THREAD_ROUTE_PATTERN.exec(routePath)?.[1];
  if (raw === undefined) return undefined;
  try {
    // routerのparams(デコード済み)と同じ値になるよう揃える
    return decodeURIComponent(raw);
  } catch {
    return undefined;
  }
}
